import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for the admin section, specifying paths using baseRoutes from the "helpers/baseRoutes" module.
 * Each route has a unique identifier and a corresponding path.
 * @constant {Object} accessRoute
 */
let BASE_ROUTES = window.location.href.includes("instructor") ? baseRoutes.instructorBaseRoutes : baseRoutes.adminBaseRoutes;
const accessRoute = {
  ADMIN_PROFILE: {
    path: `${BASE_ROUTES}/profile`,
  },
  ADMIN_CHANGE_PASSWORD: {
    path: `${BASE_ROUTES}/change-password`,
  },
  ADMIN_NOTIFICATIONS: {
    path: `${BASE_ROUTES}/notifications`,
  },
};

export default accessRoute;
